import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';

export const alertAuditSteps = [
  {
    element: '[data-onboarding="alert-audit-form"]',
    popover: {
      title: 'Quill Audit Tool',
      description:
        "Enter an alert ID (for example, A-12345) to review how Quill AI handled it. The tool shows the alert snapshot, Quill’s instructions, and lets you move between audit records.",
      align: 'start' as const,
    },
  },
];

export const alertAuditRoutes: RouteConfig[] = [
  {
    id: 'alert-audit',
    processName: ONBOARDING_KEYS.alertAudit,
    match: (path: string) => path === '/alert-audit',
    steps: alertAuditSteps,
  },
];
